import React from "react";

import TableItem from "../TableItem";

const CeremonyTable = ({
    ceremonyIds,
    onEdit,
    onSelect,
    onUnlock,
    onScriptButtonClick,
    onIlomeButtonClick,
}) => {
    return (
        <div>
            <table className="table is-hoverable is-fullwidth">
                <tbody>
                    {ceremonyIds.map((id) => (
                        <TableItem
                            key={id}
                            ceremonyId={id}
                            onEdit={onEdit}
                            onScriptButtonClick={onScriptButtonClick}
                            onSelect={onSelect}
                            onUnlock={onUnlock}
                            onIlomeButtonClick={onIlomeButtonClick}
                        ></TableItem>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default CeremonyTable;
